import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
} from '@/api/enginebrandserv'

export default {
  state: {
    state_EngineBrand_GetAllResult: null,
    state_EngineBrand_SearchByNameResult: null,
    state_EngineBrand_GetPageResult: null,
    state_EngineBrand_GetDetailResult: null,
    state_EngineBrand_AddObjResult: null,
    state_EngineBrand_ModifyObjResult: null,
    state_EngineBrand_DeleteObjResult: null,
  },
  mutations: {
    SET_ENGINEBRAND_GETALL_RESULT: (state, rst) => {
      state.state_EngineBrand_GetAllResult = rst;
    },
    SET_ENGINEBRAND_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_EngineBrand_SearchByNameResult = rst;
    },
    SET_ENGINEBRAND_GETPAGE_RESULT: (state, rst) => {
      state.state_EngineBrand_GetPageResult = rst;
    },
    SET_ENGINEBRAND_GETDETAIL_RESULT: (state, rst) => {
      state.state_EngineBrand_GetDetailResult = rst;
    },
    SET_ENGINEBRAND_ADDOBJ_RESULT: (state, rst) => {
      state.state_EngineBrand_AddObjResult = rst;
    },
    SET_ENGINEBRAND_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_EngineBrand_ModifyObjResult = rst;
    },
    SET_ENGINEBRAND_DELETEOBJ_RESULT: (state, rst) => {
      state.state_EngineBrand_DeleteObjResult = rst;
    },
  },
  actions: {
    EngineBrandServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ENGINEBRAND_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ENGINEBRAND_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EngineBrandServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ENGINEBRAND_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ENGINEBRAND_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EngineBrandServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ENGINEBRAND_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ENGINEBRAND_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EngineBrandServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ENGINEBRAND_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ENGINEBRAND_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EngineBrandServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ENGINEBRAND_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ENGINEBRAND_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EngineBrandServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ENGINEBRAND_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ENGINEBRAND_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    EngineBrandServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ENGINEBRAND_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ENGINEBRAND_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_EngineBrand_GetAllResult: state => {
      return state.state_EngineBrand_GetAllResult;
    },
    get_EngineBrand_SearchByNameResult: state => {
      return state.state_EngineBrand_SearchByNameResult;
    },
    get_EngineBrand_GetPageResult: state => {
      return state.state_EngineBrand_GetPageResult;
    },
    get_EngineBrand_GetDetailResult: state => {
      return state.state_EngineBrand_GetDetailResult;
    },
    get_EngineBrand_AddObjResult: state => {
      return state.state_EngineBrand_AddObjResult;
    },
    get_EngineBrand_ModifyObjResult: state => {
      return state.state_EngineBrand_ModifyObjResult;
    },
    get_EngineBrand_DeleteObjResult: state => {
      return state.state_EngineBrand_DeleteObjResult;
    },
  }
}